import * as React from "react";
import {ContextProps, FeatureGroup, withLeaflet} from 'react-leaflet'
import L from 'leaflet';

interface ZoomingFeatureGroupProps extends ContextProps {
    selectedFeatureTypeId: number;
    updateOnFeatureChange: boolean;
    enableAutoZoom: boolean;
}

const padding = L.point(-50, -50);
class ZoomingFeatureGroup extends React.Component<ZoomingFeatureGroupProps> {
    private nextSelectedFeatureTypeId: number;

    private readonly ref: React.RefObject<FeatureGroup>;

    constructor(props: ZoomingFeatureGroupProps) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.zoomToBounds();
    }

    zoomToBounds(forceZoom?: boolean) {
        if (!this.props.enableAutoZoom && !forceZoom) return;

        if (this.ref.current) {
            const bounds = this.ref.current.leafletElement.getBounds();
            if (bounds.hasOwnProperty("_northEast")) {
                this.props.leaflet.map.fitBounds(bounds, {padding: padding});
            }

        }
    }

    componentDidUpdate(prevProps: Readonly<ZoomingFeatureGroupProps>) {
        // XXX NVDB-6145 Typings doesn't support using children as we do here, but as long as this works (AFAIK) we'll fudge it
        const currChildren = this.props.children as [any[], any[]];
        const prevChildren = (prevProps as any).children as [any[], any[]];
        const lengthChanged = currChildren[0].length !== prevChildren[0].length || currChildren[1].length !== prevChildren[1].length;
        const primaryFeaturesContentChanged = lengthChanged || currChildren[0].some((child, index) => child.key !== prevChildren[0][index]?.key);
        const featuresChanged = primaryFeaturesContentChanged || currChildren[1].some((child, index) => child.key !== prevChildren[1][index]?.key);
        if ((this.props.selectedFeatureTypeId !== prevProps.selectedFeatureTypeId) || (this.props.updateOnFeatureChange && featuresChanged)) {
            this.zoomToBounds();
        }

    }

    render(): React.ReactNode {
        return <FeatureGroup ref={this.ref}>
            {this.props.children}
        </FeatureGroup>
    }
}

export default withLeaflet(ZoomingFeatureGroup);
